import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { errText } from "../lib/api";
import { BrandPanel, PortalToggle } from "../components/login/LoginPanels";

export default function Login() {
  const [portal, setPortal] = useState("employee");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(email, password);
      const isAdmin = user.role === "super_admin" || user.role === "hr_admin";
      navigate(isAdmin ? "/admin" : "/employee");
      toast.success(`Welcome back, ${user.name}`);
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col lg:flex-row">
      <BrandPanel />

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8 text-center">
            <img src="/dcn-logo.jpg" alt="DCN Food and Beverages" className="h-14 w-auto mx-auto rounded-lg" />
            <div className="text-xs text-stone-500 uppercase tracking-widest mt-2">HRMS</div>
          </div>

          <PortalToggle portal={portal} setPortal={setPortal} />

          <h2 className="font-heading text-2xl font-bold mb-1">{portal === "employer" ? "Employer sign in" : "Employee sign in"}</h2>
          <p className="text-sm text-stone-500 mb-6">{portal === "employer" ? "For Super Admin and HR/Admin users." : "Access attendance, leave and payslips."}</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-semibold text-stone-700">Email or Employee ID</label>
              <input type="text" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input"
                placeholder="you@dcnfoods.com or DCN0001"
                className="mt-1 w-full min-h-[48px] px-4 rounded-lg border border-stone-300 bg-white focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
            </div>
            <div>
              <label className="text-sm font-semibold text-stone-700">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input"
                placeholder="••••••••"
                className="mt-1 w-full min-h-[48px] px-4 rounded-lg border border-stone-300 bg-white focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
            </div>
            <button type="submit" disabled={busy} data-testid="login-submit-button"
              className="tap-scale w-full min-h-[52px] rounded-full bg-primary text-white font-bold hover:bg-[#A63F07] transition-colors duration-200 disabled:opacity-60">
              {busy ? "Signing in..." : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
